import { IDeliverable } from './deliverable';

export interface IAgreementIteration {
  products: IDeliverable[];
}
